/**
 * The chrome inner public pages share: brand home, the page, and a footer with the FDA line and
 * the support address. Not used on the landing page, whose hero and footer are its own.
 */
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import { useEffect } from "react";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/space.stylex";
import { radius, space } from "@lattice/tokens/space.stylex";
import "@lattice/tokens/text.stylex";
import { text } from "@lattice/tokens/text.stylex";
import { focusRing } from "@lattice/ui/focus";
import { SiteFooter, SiteHeader } from "./Site.tsx";
const GUTTER = "clamp(20px, 4vw, 56px)";
const styles = {
  skip: {
    kVAEAm: "x10l6tqk",
    k87sOh: "xhwcp2v",
    kbCHJM: "xza2og9",
    k8WAf4: "x1jyo4x1",
    kg3NbH: "x3i8z2n",
    kaIpWk: "x1m3fsnl",
    kWkggS: "xcqm4px",
    kMwMTN: "xzb3lse",
    k63SB2: "xqu410z",
    k3aq6I: "xr996gy x1cq5w7s",
    $$css: true
  }
};

/** The public address. Local wrangler still uses support@localhost for outbound mail. */
export const SUPPORT_ADDRESS = "support@latticenutrition.com";

/** `draft` is words the person already typed, so writing by email does not make them start again. */
export function supportMailto(accountId: string | null, draft = ""): string {
  if (accountId === null && draft === "") return `mailto:${SUPPORT_ADDRESS}`;
  const head = accountId === null ? "" : `Account id: ${accountId}\n\n`;
  const body = encodeURIComponent(`${head}${draft}`);
  return accountId === null ? `mailto:${SUPPORT_ADDRESS}?body=${body}` : `mailto:${SUPPORT_ADDRESS}?subject=${encodeURIComponent(`Account ${accountId}`)}&body=${body}`;
}

/** The first Tab stop on a public page, which jumps past the header to the `#main` landmark. */
export function SkipLink() {
  return <a href="#main" {...stylex.props(styles.skip, focusRing)}>
      Skip to main content
    </a>;
}
export function PublicPage({
  title,
  children
}: {
  readonly title: string;
  readonly children: ReactNode;
}) {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return <div className="x1ov3xa9 x78zum5 xdt5ytf x1l0w1cl xzb3lse x1cikjda x1rf3zrh xbz0q3o xvmahel">
      <SkipLink />
      <div className="xh8yej3 x80co2b xvueqy4 xelt9ym x9f619">
        <SiteHeader />
      </div>
      <main id="main" tabIndex={-1} className="xh8yej3 x80co2b xvueqy4 xelt9ym x9f619 x1iyjqo2 x8nvr85 x1u8hu9d">
        {children}
      </main>
      <SiteFooter />
    </div>;
}